import {Collapse, Col, FormGroup, Input, Label, Row} from "reactstrap";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import {encoderVersionOptions, encoderVersionDefault, encoderVersions, ionCubeConfigDefault, supportedEncoderVersions, parseIonCubeConfig} from "../Config";
import React from "react"


class IonCubeConfig extends React.Component {
    constructor(props) {
        super(props);
        const value = parseIonCubeConfig(props.value)
        if (value !== null) {
            let DataVar = {}
            Object.keys(value).forEach(key => {
                DataVar[key.charAt(0).toLowerCase() + key.slice(1)] = value[key]
            })
            this.state = {
                slug: DataVar.slug || ionCubeConfigDefault.slug,
                encoderVersion: DataVar.encoderVersion || ionCubeConfigDefault.encoderVersion,
                encoderVersions: DataVar.encoderVersions || ionCubeConfigDefault.encoderVersions,
                ignore: DataVar.ignore || ionCubeConfigDefault.ignore,
                copy: DataVar.copy || ionCubeConfigDefault.copy,
                commit_sha: DataVar.commit_sha || ionCubeConfigDefault.commit_sha
            }
        } else {
            this.state = ionCubeConfigDefault
        }
        this.state = {...this.state, openSections: {}}
    }

    getConfig = () => {
        // virgülle ayrılmış alanlardaki boş/boşluklu elemanları temizle
        const clean = list => (Array.isArray(list) ? list : [])
            .map(i => String(i).trim())
            .filter(i => i !== "")

        const config = {
            "slug": this.state.slug,
            "encoderVersion": (this.state.encoderVersion || "").trim(),
            "encoderVersions": clean(this.state.encoderVersions),
            "ignore": clean(this.state.ignore),
            "copy": clean(this.state.copy),
            "commit_sha": this.state.commit_sha
        }

        if (config.slug === "" && config.commit_sha === "" && config.encoderVersion === ""
            && config.encoderVersions.length === 0
            && config.ignore.length === 0
            && config.copy.length === 0)
            return null

        return config
    }

    change = () => {
        if (typeof this.props.onChange === "function") {
            this.props.onChange({
                name: this.props.name,
                value: this.getConfig()
            })
        }
    }

    // etiket (tag) girişi için yardımcılar
    toOptions = list => (Array.isArray(list) ? list : [])
        .filter(i => String(i).trim() !== "")
        .map(i => ({value: i, label: i}))

    fromOptions = e => (e === null || e === undefined ? [] : e.map(o => o.value))

    // virgül ile yapıştırılan değerleri ayrı etiketlere böl
    onTagInput = (field, current) => (value, {action}) => {
        if (action === "input-change" && value.indexOf(",") > -1) {
            const parts = value.split(",").map(i => i.trim()).filter(i => i !== "")
            const merged = Array.from(new Set([...current, ...parts]))
            this.setState({[field]: merged}, () => this.change())
            return ""
        }
        return value
    }

    renderTagField = (field, label, help, placeholder) => {
        const current = (this.state[field] || []).filter(i => String(i).trim() !== "")
        return <FormGroup>
            <Label className={"font-weight-bold mb-0"}>{label}</Label>
            <small className={"form-text text-muted mt-0 mb-1"}>{help}</small>
            <CreatableSelect
                isMulti
                isClearable
                placeholder={placeholder}
                noOptionsMessage={() => "Yazıp Enter'a basın"}
                formatCreateLabel={v => `Ekle: "${v}"`}
                components={{DropdownIndicator: null}}
                value={this.toOptions(current)}
                onInputChange={this.onTagInput(field, current)}
                onChange={e => this.setState({[field]: this.fromOptions(e)}, () => this.change())}
            />
        </FormGroup>
    }

    toggleSection = key => this.setState({openSections: {...this.state.openSections, [key]: !this.state.openSections[key]}})

    // collapsible verilirse başlığa tıklayınca açılıp kapanır; summary kapalıyken başlıkta özet gösterir
    renderSection = (title, children, collapsible, summary) => {
        if (!collapsible)
            return <div className={"bg-white border rounded p-3 mb-2"}>
                <div className={"text-uppercase text-muted small font-weight-bold mb-2"}>{title}</div>
                {children}
            </div>

        const open = !!this.state.openSections[collapsible]
        return <div className={"bg-white border rounded mb-2"}>
            <div className={"d-flex align-items-center p-3"} style={{cursor: "pointer"}}
                 onClick={() => this.toggleSection(collapsible)}>
                <i className={`mdi ${open ? "mdi-chevron-down" : "mdi-chevron-right"} mr-1`}></i>
                <span className={"text-uppercase text-muted small font-weight-bold"}>{title}</span>
                {!open && summary && <span className={"ml-auto small text-muted"}>{summary}</span>}
            </div>
            <Collapse isOpen={open}>
                <div className={"px-3 pb-3"}>{children}</div>
            </Collapse>
        </div>
    }

    countList = list => (Array.isArray(list) ? list : []).filter(i => String(i).trim() !== "").length

    // seçili base yoksa ürünün (versiyon formunda) ya da varsayılan değer geçerlidir
    effectiveBase = (base = this.state.encoderVersion) => base || this.props.inheritedBase || encoderVersionDefault

    // Base değişince yeni base'in desteklemediği PHP hedeflerini seçimden çıkar
    changeBase = (base) => {
        const allowed = supportedEncoderVersions(this.effectiveBase(base)).map(v => v.value)
        const current = Array.isArray(this.state.encoderVersions) ? this.state.encoderVersions : []
        const kept = current.filter(v => v === "" || allowed.indexOf(v) > -1)
        this.setState({encoderVersion: base, encoderVersions: kept}, () => this.change())
    }

    // Ürün formunda "Varsayılan (15.0.2)"; versiyon formunda ürünün değeri placeholder olarak gösterilir
    defaultBaseLabel = () => {
        const inherited = this.props.inheritedBase
        if (inherited)
            return `Ürünle aynı (${inherited})`
        return `Varsayılan (${encoderVersionDefault})`
    }

    render() {
        return <div className={"p-2 bg-light border rounded"}>
            {this.renderSection("Kaynak", <Row form>
                <Col md={7}>
                    <FormGroup>
                        <Label className={"font-weight-bold mb-0"}>VCS Slug</Label>
                        <small className={"form-text text-muted mt-0 mb-1"}>Depo yolu, örn. grilabs-share/woocommerce-pos</small>
                        <Input type={"text"}
                               placeholder={"organizasyon/depo"}
                               value={this.state.slug}
                               onChange={e => {
                                   this.setState({slug: e.target.value}, () => this.change())
                               }}/>
                    </FormGroup>
                </Col>
                <Col md={5}>
                    <FormGroup>
                        <Label className={"font-weight-bold mb-0"}>Spesifik Commit (sha)</Label>
                        <small className={"form-text text-muted mt-0 mb-1"}>Boşsa son commit kullanılır</small>
                        <Input type={"text"}
                               placeholder={"son commit"}
                               value={this.state.commit_sha}
                               onChange={e => {
                                   this.setState({commit_sha: e.target.value}, () => this.change())
                               }}/>
                    </FormGroup>
                </Col>
            </Row>)}

            {this.renderSection("Encoder", <Row form>
                <Col md={12}>
                    <FormGroup>
                        <Label className={"font-weight-bold mb-0"}>Encoder Sürümü</Label>
                        <small className={"form-text text-muted mt-0 mb-1"}>Boş bırakılırsa {this.props.inheritedBase ? "ürünün değeri" : `varsayılan (${encoderVersionDefault})`} kullanılır</small>
                        <Input type={"select"}
                               value={this.state.encoderVersion || ""}
                               onChange={e => {
                                   this.changeBase(e.target.value)
                               }}>
                            <option value="">{this.defaultBaseLabel()}</option>
                            {/* eski kayıtta whitelist dışı değer varsa kaybolmasın */}
                            {this.state.encoderVersion && encoderVersionOptions.every(o => o.value !== this.state.encoderVersion) &&
                                <option value={this.state.encoderVersion}>{this.state.encoderVersion} (geçersiz)</option>}
                            {encoderVersionOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                        </Input>
                    </FormGroup>
                </Col>
                <Col md={12}>
                    <FormGroup>
                        <Label className={"font-weight-bold mb-0"}>PHP Hedef Sürümleri</Label>
                        <small className={"form-text text-muted mt-0 mb-1"}>Kodun şifreleneceği PHP sürümleri (Encoder {this.effectiveBase()} destekleyenler)</small>
                        <Select
                            placeholder={"Sürüm seçin"}
                            options={supportedEncoderVersions(this.effectiveBase())}
                            noOptionsMessage={() => "Seçilecek başka sürüm yok"}
                            isMulti
                            closeMenuOnSelect={false}
                            value={encoderVersions.filter(i => {
                                return (typeof this.state.encoderVersions === "object" && this.state.encoderVersions !== null)
                                    && (this.state.encoderVersions).indexOf(i.value) > -1
                            })}
                            onChange={e => {
                                this.setState({encoderVersions: e === null ? [] : e.map(e => e.value)}, () => this.change())
                            }}
                        />
                    </FormGroup>
                </Col>
            </Row>, "encoder", `${this.state.encoderVersion || this.props.inheritedBase || "Varsayılan"} · ${this.countList(this.state.encoderVersions)} PHP hedefi`)}

            {this.renderSection("Dosya Kuralları", <Row form>
                <Col md={6}>
                    {this.renderTagField("ignore", "Hariç Tutulacaklar",
                        "Pakete hiç eklenmeyecek dizin/dosyalar", "örn. .git/, *.scss")}
                </Col>
                <Col md={6}>
                    {this.renderTagField("copy", "Şifrelenmeden Kopyalanacaklar",
                        "Pakete eklenir ama şifrelenmez", "örn. init.php")}
                </Col>
            </Row>, "rules", `${this.countList(this.state.ignore)} hariç · ${this.countList(this.state.copy)} kopya`)}
        </div>;
    }

}

export default IonCubeConfig
